<template>
  <v-data-table
    item-key="id"
    disableSort
    :items-per-page="-1"
    :headers="headers"
    :items="items"
    hide-default-footer
    class="mt-3 elevation-1"
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item | ordinalNumber(items) }}
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <CardTeacherName :teacher="item.teacher" link isCodeShown />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ item.teacher | _get('dob') | ddmmyyyy }}
    </template>
    <template v-slot:[`item.gender`]="{ item }">
      {{ item.teacher.gender | gender }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <div v-if="$_get(item, 'teacher.status')">
        <v-chip label small class="white--text" :color="item.teacher.status | teacherStatusColor">
          {{ item.teacher.status | teacherStatus }}
        </v-chip>
      </div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-menu offset-y bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon color="#0D47A1">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title
              style="cursor: pointer;"
              @click="onRemove(item.teacher)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
const headers = [
  { text: 'STT', value: 'index' },
  { text: 'Giáo viên', value: 'name' },
  {
    text: 'Ngày sinh',
    value: 'dob',
  },
  {
    text: 'Giới tính',
    value: 'gender',
    width: 100,
  },
  { text: 'Tình trạng', value: 'status' },
  { text: 'Thao tác', value: 'actions', align: 'end' },
]
export default {
  components: { CardTeacherName },
  data: () => ({ headers }),
  computed: {
    ...mapGetters({ items: 'boardingClassTeacher/items' }),
  },
  methods: {
    ...mapActions({ fetchItems: 'boardingClassTeacher/fetchItems', removeItem: 'boardingClassTeacher/removeSingle' }),
    onRemove(teacher = '') {
      this.$dialog.confirm({
        title: 'Xóa nhận xóa giáo viên?',
        text: 'Giáo viên sẽ được gỡ bỏ khỏi lớp bán trú này. Bạn có chắc chắn muốn xoá giáo viên khỏi lớp bán trú này không?',
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        type: 'delete',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeItem({ id: this.$route.params.id, teacher })
            await this.onRefresh()
            this.$alert.success('Xoá giáo viên thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
    onRefresh() {
      return this.fetchItems({ _sort: 'nameToNumber:ASC', boardingClasses: this.$route.params.id })
    },
  },
  async mounted() {
    await this.onRefresh()
  },
}
</script>
